import { defineMessages } from 'react-intl'

export default defineMessages({
  audienceSentence: {
    id: 'AudienceSimpleRule.Sentence',
    defaultMessage: 'Targeted to {audienceText}'
  },
  audienceSentenceManual: {
    id: 'AudienceSimpleRule.SentenceManual',
    defaultMessage: 'To {audienceText}'
  },
  attributeBooleanTruthy: {
    id: 'AudienceSimpleRule.Attribute.Boolean.Truthy',
    defaultMessage: 'who are {attributeName}'
  },
  attributeBooleanFalsyPrefix: {
    id: 'AudienceSimpleRule.Attribute.Boolean.Falsy',
    defaultMessage: 'who are not {attributeName}'
  },
  attributePossesive: {
    id: 'AudienceSimpleRule.Attribute.Possesive',
    defaultMessage: 'with the {attributeName} {value}'
  },
  notAttributePossesive: {
    id: 'AudienceSimpleRule.Attribute.Not.Possesive',
    defaultMessage: 'without the {attributeName} {value}'
  },
  attributeInclusive: {
    id: 'AudienceSimpleRule.Attribute.Inclusive.',
    defaultMessage: 'in the {attributeName} {value}'
  },
  notAttributeInclusive: {
    id: 'AudienceSimpleRule.Attribute.Not.Inclusive.',
    defaultMessage: 'not in the {attributeName} {value}'
  },
  attributePersonal: {
    id: 'AudienceSimpleRule.Attribute.Personal.',
    defaultMessage: 'who are {value}'
  },
  notAttributePersonal: {
    id: 'AudienceSimpleRule.Attribute.Not.Personal.',
    defaultMessage: 'who are not {value}'
  },
  ruleAllUsers: {
    id: 'AudienceSimpleRule.Rule.AllUsers.',
    defaultMessage: 'All Users'
  },
  ruleAllManagers: {
    id: 'AudienceSimpleRule.Rule.AllManagers.',
    defaultMessage: 'Managers of All Users'
  },
  ruleStartPrefixUser: {
    id: 'AudienceSimpleRule.Rule.User.Prefix.',
    defaultMessage: 'users'
  },
  ruleStartPrefixManager: {
    id: 'AudienceSimpleRule.Rule.Manager.Prefix.',
    defaultMessage: 'managers of users'
  }
})
